import { MessageCircle, Instagram, Phone } from "lucide-react";
import { Logo } from "./Logo";
import {
    NAV_LINKS,
    scrollToId,
    whatsappLink,
    PHONE_DISPLAY,
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
} from "@/data";

export const Footer = () => (
    <footer
        data-testid="main-footer"
        className="bg-navy-900 noise-bg border-t border-white/10 pt-16 pb-8"
    >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
                <div>
                    <Logo className="h-16" />
                    <p className="mt-5 text-white/50 text-sm leading-relaxed max-w-xs">
                        Higienização profissional para cuidar do que é importante para você.
                        Qualidade, cuidado e confiança em cada serviço.
                    </p>
                </div>

                <div>
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-white/40 mb-5">
                        Navegação
                    </p>
                    <nav className="grid grid-cols-2 gap-x-6 gap-y-3">
                        {NAV_LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="text-left text-sm text-white/60 hover:text-brand transition-colors duration-300"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                </div>

                <div>
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-white/40 mb-5">
                        Contato
                    </p>
                    <div className="space-y-3">
                        <a
                            data-testid="footer-whatsapp-link"
                            href={whatsappLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-sm text-white/60 hover:text-brand transition-colors duration-300"
                        >
                            <MessageCircle className="w-4 h-4 text-brand" />
                            WhatsApp {PHONE_DISPLAY}
                        </a>
                        <a
                            data-testid="footer-phone-link"
                            href={`tel:+55${PHONE_DISPLAY.replace(/\D/g, "")}`}
                            className="flex items-center gap-3 text-sm text-white/60 hover:text-brand transition-colors duration-300"
                        >
                            <Phone className="w-4 h-4 text-brand" />
                            {PHONE_DISPLAY}
                        </a>
                        <a
                            data-testid="footer-instagram-link"
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-sm text-white/60 hover:text-brand transition-colors duration-300"
                        >
                            <Instagram className="w-4 h-4 text-brand" />
                            {INSTAGRAM_HANDLE}
                        </a>
                    </div>
                </div>
            </div>
            <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p
                    data-testid="footer-copyright"
                    className="text-xs text-white/40"
                >
                    © {new Date().getFullYear()} Brandão Morais Higienização. Todos os direitos
                    reservados.
                </p>
                <p className="text-xs text-white/30">
                    Higienização profissional • Limpeza de estofados • Impermeabilização
                </p>
            </div>
        </div>
    </footer>
);
